<template>
    <div>
        <v-card style="height: 100%">
            <v-toolbar
                flat
                outlined
                v-if="gateway !== null"
                height="unset"
                class="py-2"
            >
                <v-toolbar-title >
                    <p class="subtitle-1 text-uppercase font-weight-bold ma-0 primary--text" style="white-space: normal">
                        {{ gateway.name }}
                    </p>
                    <p class="caption ma-0" v-if="lastReadings && lastReadings.length">
                        Última lecturas: 
                    </p>
                    <p class="caption ma-0">{{ timeReading }}</p>
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-card :color="colorIcon" flat dark class="ml-5">
                    <v-card-text class="pa-3">
                        <v-icon small>mdi-flash</v-icon>
                    </v-card-text>
                </v-card>
            </v-toolbar>
            <v-card-text class="" v-if="gateway">
                <p>{{ gateway.address }}</p>
                <v-img :src="gateway.url_img" max-height="130px" class="my-2"></v-img>
                <GmapMap
                    ref="map"
                    :center="{
                        lat: gateway.location.latitude,
                        lng: gateway.location.longitude,
                    }"
                    :zoom="17"
                    :options="{
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                    }"
                    map-type-id="roadmap"
                    class="map my-2"
                >

                    <GmapMarker
                        id="gateway.name"
                        v-if="gateway.location"
                        :position="{
                            lat: gateway.location.latitude,
                            lng: gateway.location.longitude,
                        }"
                        :icon="{ url: require('@/assets/map/icon.png') }"
                    />
                    
                </GmapMap>
                <v-list dense class="my-2">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="primary--text">Número de paneles: </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            {{ gateway.panels }}
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="primary--text">Número de inversores: </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            {{ gateway.inverters }}
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title class="primary--text">Tarifa: </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            {{ gateway.rate }}
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <template v-for="(meter, i) in meters">
                        <div :key="meter.name">
                            <v-list-group
                                no-action
                                class="pr-2"
                            >
                                <template v-slot:activator>
                                    <v-list-item-content>
                                        <v-list-item-title class="primary--text" v-if="meter.type === 'consumption'">Consumo ({{meter.name}})</v-list-item-title>
                                        <v-list-item-title class="primary--text" v-else>Generación ({{meter.name}})</v-list-item-title>
                                    </v-list-item-content>
                                </template>

                                <v-list-item class="pl-4" >
                                    <v-list-item-content>
                                        <v-list-item-title>Total de watts</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="lastReadings && lastReadings.length">
                                        {{lastReadings.find(r => r.meter == meter.name).lines.reduce( (suma, l) => suma + l.watts, 0 ).toFixed(2)}}
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="pl-4">
                                    <v-list-item-content>
                                        <v-list-item-title>Total de amps</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="lastReadings && lastReadings.length">
                                        {{lastReadings.find(r => r.meter == meter.name).lines.reduce( (suma, l) => suma + l.amps, 0 ).toFixed(2)}}
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="pl-4" >
                                    <v-list-item-content>
                                        <v-list-item-title>volt</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="lastReadings && lastReadings.length">
                                        {{(Object.entries(
                                            lastReadings.find(r => r.meter == meter.name).lines.reduce( (acc, l) => 
                                                l.volts > 10 
                                                    ? acc = { suma: acc.suma + l.volts, lines: acc.lines + 1} : acc , 
                                                    { suma: 0, lines: 0} )
                                            ).reduce( (total, el) => {
                                                if(el[0] == 'suma') return total + el[1];
                                                else if(total == 0) return 0;
                                                else return total / el[1]
                                            }, 0)).toFixed(2)
                                        }}
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list-group>
                            <v-divider v-if="(meters.length - 1) != i"></v-divider>
                        </div>
                    </template>
                </v-list>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'info',
    props: ['gateway', 'meters', 'lastReadings'],
    computed: {
        ...mapState({
            minutesToWarn: state => state.account.profile.minutesToWarn,
            minutesToDanger: state => state.account.profile.minutesToDanger
        }),
        timeReading(){
            if(!this.lastReadings) return ''
            const reads =  this.lastReadings.reduce( (time, read) => 
                    time += new Date(read.timestamp).toLocaleString() + ' - '
                , '')
            
            return reads.substring(0, reads.length - 3)
        },
        colorIcon(){
            if(!this.lastReadings) return 'blue-grey darken-1'
            const time = new Date(
                this.lastReadings.reduce( (time, read) => 
                    read.timestamp < time || time == '' ? read.timestamp : time
                , '')).getTime()
            
            const diff = (new Date().getTime() - time) / (1000 * 60)
            
            if(diff > this.minutesToDanger) return 'red darken-3'
            else if(diff > this.minutesToWarn) return 'yellow accent-4'
            else return 'accent'
        }
    }
}
</script>

<style scoped>
    .v-toolbar{
        height: unset;
    }
    .map{
        height: 200px;
        width: 100%;
        overflow: hidden;
    }
    .action-btn{
        position: absolute;
        bottom: 10px;
        left: 10px;
        right: 10px;
    }
</style>